'use strict';

const cookieHelper = require('friartux/components/cookieHelper');
const formValidation = require('friartux/components/formValidation');
const phoneUtils = require('friartux/utils/phone');
const purechatUtils = require('friartux/utils/purechat');
var createErrorNotification = require('../components/errorNotification');

const swatchCookieName = 'ft-swatch';
const cookieLife = 30;
const bagLimit = 5;

var defaultBottomPadding = 45;

var bag = [];

const SELECTORS = {
    body: 'body',
    addToBag: '.js-swatch-add-to-bag',
    removeSwatch: '.js-remove-swatch',
    removeAll: '.js-remove-all-swatch',
    swatchImg: '.js-swatch-img',
    swatchName: '.js-swatch-name',
    selectedSwatchCount: '.js-selected-swatch-label',
    selectedSwatchTileTpl: '.js-swatch-tile-tpl',
    selectedSwatchContainer: '.js-selected-swatch-container',
    swatchProduct: '.js-swatch-product',
    swatchPhone: '.js-swatch-phone',
    swatchBag: '.swatch-bag',
    swatchCheckoutBtn: '.js-swatch-checkout',
    swatchCheckoutForm: '.js-swatch-checkout-form',
    swatchCheckoutFormSubmitBtn: '.js-swatch-checkout-form-submit',
    swatchCheckoutModal: '#swatchCheckoutModal',
    finePrint: '.js-swatch-fine-print',
    confirmation: '.js-confirmation',
    modalTitle: '.modal-title',
    doneBtn: '.js-swatch-done'
};

/**
 * Initializes the swatch bag:
 * - Loads existing swatches from cookie
 * - Binds event listeners for add/remove/checkout
 * - Watches for Purechat widget to adjust UI
 */
function init() {
    getBag();

    $(SELECTORS.body).on('click', SELECTORS.addToBag, handleAddSwatchToBag);
    $(SELECTORS.body).on('click', SELECTORS.removeSwatch, handleRemoveSwatchToBag);
    $(SELECTORS.body).on('click', SELECTORS.removeAll, handleRemoveAllSwatchToBag);
    $(SELECTORS.body).on('click', SELECTORS.swatchCheckoutBtn, handleCheckoutBtn);
    $(SELECTORS.body).on('click', SELECTORS.swatchCheckoutFormSubmitBtn, handleSwatchCheckout);
    initCheckoutForm();
    phoneUtils.formatPhone(SELECTORS.swatchPhone);

    // Purechat is Cookiebot-gated (preferences + statistics), so the widget may only
    // appear after the visitor accepts - purechatUtils waits for that.
    purechatUtils.onReady(watchPurechat);
}

/**
 * Hooks into Purechat widget events to adjust swatch bag bottom padding when
 * chatbox changes.
 */
function watchPurechat() {
    const swatchBag = $(SELECTORS.swatchBag)[0];
    let purechatApi = window.purechatApi;

    if (!swatchBag) {
        return;
    }

    purechatApi.on('chatbox:ready', function () {
        resizeSwatchBag();
    });

    purechatApi.on('chatbox:collapse', function () {
        let bottomPadding = $(SELECTORS.purechatWidget).height();
        $(SELECTORS.swatchBag).css('padding-bottom', bottomPadding + 'px');
    });

    purechatApi.on('chatbox:minimize', function () {
        $(SELECTORS.swatchBag).css('padding-bottom', defaultBottomPadding + 'px');
    });
}

/**
 * Resizes swatch bag padding dynamically when window is resized, taking into
 * account the Purechat widget visibility/collapse state.
 */
function resizeSwatchBag() {
    $(window).on('resize', function() {
        let windowWidth = $(window).width();

        if (windowWidth <= 768) {
            const $pureChatWindow = $(SELECTORS.purechatWindow);
            let bottomPadding = defaultBottomPadding;

            if ($pureChatWindow.hasClass('purechat-widget-collapsed')) {
                bottomPadding = $(SELECTORS.purechatWidget).height();
            }

            $(SELECTORS.swatchBag).css('padding-bottom', bottomPadding + 'px');
        }
    });
}

/**
 * Event handler: Add a swatch to bag and update UI.
 */
const handleAddSwatchToBag = (e) => {
    let $this = $(e.currentTarget);
    let swatchId = $this.data('swatch-id');
    let added = addToBag(swatchId);

    if (added) {
        $this.closest(SELECTORS.swatchProduct).addClass('selected');
    }
}

/**
 * Event handler: Remove a swatch from bag and update UI.
 */
const handleRemoveSwatchToBag = (e) => {
    let $this = $(e.currentTarget);
    let swatchId = $this.data('swatch-id');
    let removed = removeFromBag(swatchId);

    if (removed) {
        $(SELECTORS.swatchProduct + '-' + swatchId).removeClass('selected');
    }
}

/**
 * Event handler: Clear all swatches from the bag.
 */
const handleRemoveAllSwatchToBag = () => {
    clearBag();
}

const handleCheckoutBtn = () => {
    //$(SELECTORS.swatchBag).fadeOut();
}

/**
 * Event handler: Checkout button click handler.
 */
const handleSwatchCheckout = () => {
    $(SELECTORS.swatchCheckoutForm).trigger('submit');
}

/**
 * Updates swatch bag count displayed in UI and enables checkout button if items
 * exist.
 */
function updateBagCount() {
    $(SELECTORS.selectedSwatchCount).text(bag.length);

    if (bag.length > 0) {
        // Enable checkout button.
        $(SELECTORS.swatchCheckoutBtn).attr('disabled', false);
        $(SELECTORS.removeAll).show();
    } else {
        // Disabled checkout button.
        $(SELECTORS.swatchCheckoutBtn).attr('disabled', true);
        $(SELECTORS.removeAll).hide();
    }
}

/**
 * Adds a swatch to the bag DOM (selected list).
 */
function addSelectedSwatchToBagDom(swatchId) {
    let $selectedSwatch = $(SELECTORS.swatchProduct + '-' + swatchId);
    $selectedSwatch.addClass('selected');
    let swatchImg = $selectedSwatch.find(SELECTORS.swatchImg).clone();
    let swatchName = $selectedSwatch.find(SELECTORS.swatchName);

    let $newSelectedSwatch = $(SELECTORS.selectedSwatchTileTpl).clone();
    $newSelectedSwatch.removeClass('d-none js-swatch-tile-tpl');
    $newSelectedSwatch.find(SELECTORS.swatchImg).append(swatchImg);
    $newSelectedSwatch.find(SELECTORS.swatchName).text(swatchName.text());
    $newSelectedSwatch.find(SELECTORS.removeSwatch).data('swatch-id', swatchId);
    $newSelectedSwatch.addClass('js-swatch-product-' + swatchId);

    $(SELECTORS.selectedSwatchContainer).append($newSelectedSwatch);
}

/**
 * Removes a swatch from the bag DOM (selected list).
 */
function removeSelectedSwatchFromBagDom(swatchId) {
    $(SELECTORS.swatchProduct + '-' + swatchId).removeClass('selected');
    $(SELECTORS.selectedSwatchContainer).find(SELECTORS.swatchProduct + '-' + swatchId).remove();
}

/**
 * Adds a swatch to the bag.
 */
function addToBag(swatchId) {
    let added = false;

    if (bag.length < bagLimit && bag.indexOf(swatchId) < 0) {
        bag.push(swatchId);
        saveBag();
        addSelectedSwatchToBagDom(swatchId);
        added = true;
    }

    return added;
}

/**
 * Removes a swatch from the bag if it exists.
 */
function removeFromBag(swatchId) {
    let removed = false;
    let index = bag.indexOf(swatchId);
    if (index != -1) {
        bag.splice(index, 1);
        saveBag();
        removeSelectedSwatchFromBagDom(swatchId);
        removed = true;
    }

    return removed;
}

/**
 * Clears the entire bag:
 * - Deletes cookie
 * - Removes swatches from DOM
 * - Resets bag array
 */
function clearBag() {
    cookieHelper.deleteCookie(swatchCookieName);
    bag.forEach(function (element) {
        removeSelectedSwatchFromBagDom(element);
    });
    bag = [];

    updateBagCount();
}

/**
 * Loads swatch bag from cookie and updates DOM.
 */
function getBag() {
    let swatchBag = cookieHelper.getCookie(swatchCookieName);
    if (swatchBag) {
        swatchBag = JSON.parse(swatchBag);
        bag = swatchBag;
        bag.forEach(function (element) {
            addSelectedSwatchToBagDom(element);
        });

        updateBagCount();
    }
}

/**
 * Saves the current swatch bag to cookie and updates UI count.
 */
function saveBag() {
    let swatchBag = JSON.stringify(bag);
    cookieHelper.setCookie(swatchCookieName, swatchBag, cookieLife);

    updateBagCount();
}

function initCheckoutForm() {
    $(SELECTORS.swatchCheckoutForm).on('submit', function (e) {
        let $form = $(this);
        let formData = $form.serialize();
        formData = formData.replaceAll('dwfrm_swatch_', '');
        formData += '&swatch=' + bag.toString();

        e.preventDefault();

        let url = $form.attr('action');
        $form.spinner().start();

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                }

                if (data.success) {
                    $(SELECTORS.confirmation)
                        .data('submitted', true)
                        .removeClass('d-none');
                    $(SELECTORS.swatchCheckoutForm).hide();
                    $(SELECTORS.finePrint).hide();
                    $(SELECTORS.modalTitle).hide();

                    cookieHelper.deleteCookie(swatchCookieName);
                }
            },
            error: function (err) {
                $form.spinner().stop();
                createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
            }
        });

        return false;
    });

    $(SELECTORS.body).on('hidden.bs.modal', SELECTORS.swatchCheckoutModal, function () {
        if ($(SELECTORS.confirmation).data('submitted')) {
            clearBag();
            const homepageUrl = $(SELECTORS.doneBtn).data('homepage-url');
            window.location = homepageUrl;
        }
    });
}



module.exports = {
    init: init
};
